import Vue from 'vue'

export default{
    getPedidos(parametros){
        return Vue.axios.get("comida-pedido/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getPedido(id){
        return Vue.axios.get("comida-pedido/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updatePedido(parametros){
        return Vue.axios.put("comida-pedido", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    cancelPedido(parametros){
        return Vue.axios.post("comida-pedido/cancela",parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    addPedido(parametros){
        return Vue.axios.post("comida-pedido", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },  
    descargarReporte(parametros){
        return Vue.axios({
            method:"GET",
            responseType:"blob",
            url:"comida-pedido/reporte",
            params:parametros
        }).then((response)=> Promise.resolve(response)).catch((error)=>Promise.reject(error))
    } 
}